import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "./filters/date";

Vue.config.productionTip = false;

import "./styles/main.scss";
import vuetify from "./plugins/vuetify";
import "./plugins/gtm";

import Vue2Editor from "vue2-editor";

Vue.use(Vue2Editor);

Vue.component("m-alert", () => import("./components/Alert"));
Vue.component("m-dialog", () => import("./components/Dialog"));


const options = {
  confirmButtonColor: '#973133',
  cancelButtonColor: '#8a7038',
};

import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';
Vue.use(VueSweetalert2, options);


new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount("#app");
